import React, { useEffect, useState } from "react";
import axios from "axios";
import Fade from "react-reveal/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import LazyLoad from "react-lazyload";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import SectionWrapper, {
  Container,
  HeaderWrapper,
  HeaderLeft,
  Eyebrow,
  SectionTitle,
  Subtitle,
  HeaderRight,
  NavButtons,
  SwiperWrapper,
  VideoCard,
  VideoFrameWrapper,
} from "./watchVideos.style";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const fallbackVideoIds = [
  "r4rB6i-oB4g",
  "kX3GqQoJ9ZQ",
  "dZ4X6lQW8yM",
];

const WatchVideos = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          "https://radianceadmin.manageprojects.in/api/gallery-videos"
        );
        if (response.data.success && response.data.data.length > 0) {
          const apiVideos = response.data.data[0].youtubevideos;
          if (Array.isArray(apiVideos) && apiVideos.length > 0) {
            setVideos(apiVideos);
          }
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  const displayVideos = videos.length > 0 ? videos : fallbackVideoIds;

  return (
    <SectionWrapper id="watchVideos">
      <Container>
        <Fade top>
          <HeaderWrapper>
            <HeaderLeft>
              <Eyebrow>Real Transformations & Stories</Eyebrow>
              <SectionTitle>Watch Our Videos</SectionTitle>
              <Subtitle>
                See firsthand how our expert non-surgical hair systems restore natural look, youthfulness, and confidence.
              </Subtitle>
            </HeaderLeft>

            <HeaderRight>
              <NavButtons>
                <div
                  className="swiper-button-prev7"
                  aria-label="Previous videos"
                  role="button"
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div
                  className="swiper-button-next7"
                  aria-label="Next videos"
                  role="button"
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              </NavButtons>
            </HeaderRight>
          </HeaderWrapper>
        </Fade>

        <Fade bottom>
          <SwiperWrapper>
            <Swiper
              spaceBetween={24}
              slidesPerView={3}
              navigation={{
                prevEl: ".swiper-button-prev7",
                nextEl: ".swiper-button-next7",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1.15,
                  spaceBetween: 14,
                },
                576: {
                  slidesPerView: 1.6,
                  spaceBetween: 16,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }}
            >
              {displayVideos.map((videoId, index) => (
                <SwiperSlide key={`${videoId}-${index}`}>
                  <VideoCard>
                    <VideoFrameWrapper>
                      <LazyLoad height="100%" offset={120} once>
                        <iframe
                          src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                          title={`Radiance Hair Studio - Video ${index + 1}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </LazyLoad>
                    </VideoFrameWrapper>
                  </VideoCard>
                </SwiperSlide>
              ))}
            </Swiper>
          </SwiperWrapper>
        </Fade>
      </Container>
    </SectionWrapper>
  );
};

export default WatchVideos;
